// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1bec6fb8","455":"3af4f3e4","977":"e8bd13c1"}[chunkId] + ".chunk.js";
};